/**
 * useEvents Hook - 事件数据获取
 */

import { useQuery } from '@tanstack/react-query'
import { eventsApi } from '../api/events'
import { useLanguage } from './useLanguage'

// 获取日期列表
export function useDates() {
  return useQuery({
    queryKey: ['dates'],
    queryFn: () => eventsApi.getDates(),
    staleTime: 1000 * 60 * 10,
  })
}

// 获取事件列表
export function useEvents(params: {
  date?: string
    narrative?: string
    token?: string
  page?: number
  limit?: number
}) {
  const { lang } = useLanguage()
  return useQuery({
    queryKey: ['events', params, lang],
    queryFn: () => eventsApi.getEvents({ ...params, lang }),
    enabled: !!params.date,
  })
}

// 获取事件详情
export function useEvent(eventId: string | undefined, date?: string) {
  const { lang } = useLanguage()
  return useQuery({
    queryKey: ['event', eventId, date, lang],
    queryFn: () => {
      if (!eventId) throw new Error('Event ID is required')
      return eventsApi.getEvent(eventId, date, lang)
    },
    enabled: !!eventId,
  })
}

// 获取叙事统计
export function useNarratives(date?: string) {
  const { lang } = useLanguage()
  return useQuery({
    queryKey: ['narratives', date, lang],
    queryFn: () => eventsApi.getNarratives(date, lang),
  })
}
